import { cn } from "@/lib/utils";
import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

export const ProductCard = ({ product, className }) => {
  return (
    <Link to={`/products/${product.id}`} className="block group">
      <Card className={cn("overflow-hidden card-hover border-border/50", className)}>
        {/* Image */}
        <div className="aspect-[4/5] overflow-hidden bg-secondary/30">
          <img
            src={product.image}
            alt={product.name}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        
        {/* Content */}
        <CardContent className="p-4">
          {/* Tags */}
          <div className="flex flex-wrap gap-1 mb-2">
            {product.tags.slice(0, 2).map((tag, index) => (
              <Badge key={index} variant="secondary" className="text-xs font-normal">
                {tag}
              </Badge>
            ))}
          </div>

          {/* Name & Description */}
          <h3 className="font-display text-lg font-medium text-foreground group-hover:text-primary transition-colors">
            {product.name}
          </h3>
          <p className="text-sm text-muted-foreground mt-1 line-clamp-1">
            {product.shortDesc}
          </p>

          {/* Price */}
          <p className="mt-3 font-medium text-foreground">
            €{product.price}
          </p>
        </CardContent>
      </Card>
    </Link>
  );
};
